import { Skeleton } from '../../../Skeleton'

import * as styles from './EntityPhaseLoading.module.css'

function EntityPhaseLoading({ className = styles.EntityPhaseLoading }) {
  return (
    <div className={className}>
      <Skeleton className={styles.skeleton} />
    </div>
  )
}

export default EntityPhaseLoading
